import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInformationCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0M7 3v2h2V3zM6 13h3V9h1V7H7v4H6z",
		clipRule: "evenodd"
	})
});
export default SvgInformationCircle;
